// Payment Configuration
export const CLOUDPAYMENTS_PUBLIC_ID = 'pk_a0f648514746b0c69774378b2a1ef';
export const PAYMENT_CURRENCY = 'RUB';

// Generation status texts
export const GENERATION_STATUS_TEXTS = [
    'Звезда в шоке и начала учить текст…',
    'Звезда надевает своё лучшее белье для ролика',
    'Звезда хочет просто лежать на диване,\nно мы заставляем ее работать',
    'Свет. Камера. Мотор. Уже выехал за селебом.',
    'Звезда повторяет текст в такси',
    'Немного волнуется…потеет ради вас',
    'Осталось немного, генерация уже давно идет',
    'Сотни компуктеров делают вам видео',
    'Почему морские звезды не селебрити?',
    'Скоро всё будет готово',
    'Соединяем видеоряд и озвучку',
    'Сохраняем файл на серверах',
    'К звезде выстроилась очередь для пофоткаться',
    'Мы тоже ждём…',
    'Ща, уже скоро',
    'Видео отправляется…',
    'Спасибо, что были вместе с этим текстом.'
];
